import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  height: 100vh;
  width: 100vw;
  position: relative;

  .logo-container {
    position: relative;
    top: 30px;
    left: 30px;
    display: block;
  }

  .SaasOnboardingPricingTiers-container {
    padding-top: 120px;
  }

  .asterisk-text {
    padding-bottom: ${spacing(12)};
  }

  .footer-container {
    margin-top: ${spacing(6)};
    padding-bottom: 60px;
  }
`
